import { Component, Input } from '@angular/core';
import { NeskoAbEigentumListEntry } from 'app/core/amtlichebewertung-api';
import { ListLoader } from 'app/shared/components/list-loader/list-loader';
import { NeskoAbEigentumListEntryVm, NeskoabViewmodelService } from 'app/neskoab/neskoab-viewmodel.service';
import { ListLoaderPreloaded } from 'app/shared/components/list-loader/list-loader-preloaded';
import { LinkComponent, NavTarget } from '../../../shared/components/link/link.component';
import { ListLoaderWrapperComponent } from '../../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { KompaktPersonenadresseComponent } from '../../../shared/kompaktdarstellung/personenadresse/kompakt-personenadresse.component';
import { TranslatePipe } from '@ngx-translate/core';
import { DecimalHochkommaPipe } from '../../../shared/pipes/simple/decimalHochkomma.pipe';

@Component({
  selector: 'cap-neskoab-personen-eigentum',
  templateUrl: './neskoab-personen-eigentum.component.html',
  styleUrls: ['./neskoab-personen-eigentum.component.scss'],
  imports: [
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    NgClass,
    KompaktPersonenadresseComponent,
    LinkComponent,
    TranslatePipe,
    DecimalHochkommaPipe
  ]
})
export class NeskoabPersonenEigentumComponent {
  _eigentum: Array<NeskoAbEigentumListEntry>;

  listLoader: ListLoader<NeskoAbEigentumListEntryVm>;

  navTargets = NavTarget;

  @Input()
  hasRight = false;

  constructor(private neskoabViewmodelService: NeskoabViewmodelService) {}

  @Input()
  set eigentum(value: Array<NeskoAbEigentumListEntry>) {
    if (!value) {
      return;
    }
    const eigentum = this.neskoabViewmodelService.getViewModel(value);
    this.listLoader = new ListLoaderPreloaded<NeskoAbEigentumListEntryVm>(undefined, 1, eigentum);
    this._eigentum = value;
  }

  indent(eigentum: NeskoAbEigentumListEntry) {
    return {
      'padding-left': +eigentum.level * 10 + 'px'
    };
  }
}
